<template>
  <div class="container" v-if="!MojavezPage">
    <div class="row">
      <div class="col-12 alert alert-danger py-3">
        <div class="text-center"><h5>مشتری گرامی با عرض پوزش شما قادر به استفاده از این سامانه نمی باشید ، برای خرید سامانه از راه های زیر میتوانید اقدام فرمایید</h5></div>
        <div class="mt-4 text-center"><h6 class="text-dark">(امکان خرید آنلاین و فعال سازی در لحظه به زودی برای شما مشتریان عزیز فراهم خواهد شد)</h6></div>
        <div class="text-center"><h6>ارسال تیکت از طریق سامانه جامع پاسارگاد و منوی ارسال تیکت با عنوان فعال سازی سامانه مودیان</h6></div>
        <div class="text-center"><h6>تماس با شماره تماس های واحد فروش : ۳۳۴۵۳۵۳۳-۰۳۱ و ۳۳۴۵۳۸۸۷-۰۳۱ و ۰۹۱۲۸۳۵۸۳۹۳</h6></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        MojavezPage:false
    }
  },
  methods: {
    ChackupTaxSale() {
      return new Promise((success, fail) => {
        var SendData = { Action: 'TaxSale', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
        var formData = new FormData()
        formData.append('CustomerCode', this.$session.get('CustomerInfo').CustomerCode)
        formData.append('DateNow', this.$GetJalaliDate())
        SendData.ArryfildValue = formData
        this.$PostFormData(SendData).then((result) => {
          success(result.data[0].isMojaz)
        })
      })
    },
  },
  mounted() {
    this.ChackupTaxSale().then((val) => {
      if (val == 'true') {
        this.MojavezPage=true
        this.$emit('StateMojavez',true)
      }
      else{
        this.MojavezPage=false
      }
    })
  }
}
</script>
